import { schemaMigrations } from '@nozbe/watermelondb/Schema/migrations'

import v2_message_tables from '../migrations/V2_messages_tables'
import V3_chats_normalized_search_column from '../migrations/V3_chats_normalized_search_column'
import V4_chat_key_column from '../migrations/V4_chat_key_column'
import V5_chat_last_user_name_column from '../migrations/V5_chat_last_user_name_column'
import V6_messages_templates_columns from '../migrations/V6_messages_templates_columns'
import V7_messages_contacts_column from '../migrations/V7_messages_contacts_column'
import V8_messages_table from '../migrations/V8_messages_table'
import V9_message_location from '../migrations/V9_message_location'
import V10_message_flow from '../migrations/V10_message_flow'
import V11_message_reply_message from '../migrations/V11_message_reply_message'
import V12_message_referral_columns from '../migrations/V12_message_referral_columns'
import V13_chat_has_client_message from '../migrations/V13_chat_has_client_message'
import v14_chat_contact_blocked from '../migrations/V14_chat_contact_blocked'
import V15_chat_tags_column from '../migrations/V15_chat_tags_column'
import v16_chat_last_session from '../migrations/V16_chat_last_session'
import v17_chat_ai_session from '../migrations/V17_chat_ai_session'
import v18_chat_client_summary from '../migrations/V18_chat_client_summary'

/* 
  ------------ IMPORTANTE ------------
  
  PARA MIGRAÇÕES SEGUIR O PIPELINE DESSE LINK
  https://watermelondb.dev/docs/Advanced/Migrations

  ------------ IMPORTANTE ------------
*/

export default schemaMigrations({
  migrations: [
    v2_message_tables,
    V3_chats_normalized_search_column,
    V4_chat_key_column,
    V5_chat_last_user_name_column,
    V6_messages_templates_columns,
    V7_messages_contacts_column,
    V8_messages_table,
    V9_message_location,
    V10_message_flow,
    V11_message_reply_message,
    V12_message_referral_columns,
    V13_chat_has_client_message,
    v14_chat_contact_blocked,
    V15_chat_tags_column,
    v16_chat_last_session,
    v17_chat_ai_session,
    v18_chat_client_summary
  ]
})
